import I18n from 'I18n';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton';
import UICharacterCounter from 'UIComponents/counters/UICharacterCounter';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import UIModal from 'UIComponents/dialog/UIModal';
import UITextArea from 'UIComponents/input/UITextArea';
import ToolAccessModalError from './components/modal/ToolAccessModalError';
import ApproverSelect from './components/ApproverSelect';
import { useToolAccessRequestForm } from './hooks/useToolAccessRequestForm';
import { trackInteraction } from './utils/usageTracker';
import { CHANGE_APPROVER, SUBMIT_REQUEST, CANCEL_REQUEST, OPEN_MODAL } from './constants/trackingConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ToolAccessModal(props) {
  const {
    onClose,
    onComplete,
    show,
    toolAccess
  } = props;
  const {
    formState,
    setError,
    setApprover,
    setMessage,
    resetForm
  } = useToolAccessRequestForm();
  if (!show) {
    return null;
  }
  const onOpenStart = () => {
    trackInteraction(OPEN_MODAL);
  };
  const onRequestError = error => {
    setError(error.responseJSON);
  };
  const onSubmit = evt => {
    evt.preventDefault();
    setError(null);
    if (!formState.approver) {
      return;
    }
    const data = {
      approver: formState.approver,
      message: formState.message
    };
    toolAccess.createRequest(data, response => {
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "toolAccess.requestSent"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "toolAccess.requestSentToApprover",
          options: Object.assign({}, formState.approver)
        }),
        type: 'success',
        'data-test-id': 'ui-tool-access-request-sent-alert'
      });
      if (typeof onComplete === 'function') {
        onComplete(response);
      }
    }, onRequestError);
    trackInteraction(SUBMIT_REQUEST);
  };
  const onChangeApprover = approver => {
    setApprover(approver);
    trackInteraction(CHANGE_APPROVER);
  };
  const onChangeMessage = evt => {
    setMessage(evt.target.value);
  };
  const onCancel = () => {
    onClose();
    resetForm();
    trackInteraction(CANCEL_REQUEST);
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "ui-tool-access-request-modal",
    width: 600,
    onOpenStart: onOpenStart,
    children: [toolAccess.loading && /*#__PURE__*/_jsx(UILoadingOverlay, {
      contextual: true
    }), /*#__PURE__*/_jsxs(UIForm, {
      onSubmit: onSubmit,
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "toolAccess.requestPermissionUpdate"
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onCancel
        })]
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [formState.error && /*#__PURE__*/_jsx(ToolAccessModalError, {
          error: formState.error
        }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "toolAccess.modalDescription",
          options: {
            toolName: toolAccess.toolName
          }
        }), /*#__PURE__*/_jsx(UIFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "toolAccess.approver"
          }),
          required: true,
          children: /*#__PURE__*/_jsx(ApproverSelect, {
            value: formState.approver,
            onChange: onChangeApprover
          })
        }), /*#__PURE__*/_jsx(UICharacterCounter, {
          onChange: onChangeMessage,
          value: formState.message,
          renderInput: readerProps => /*#__PURE__*/_jsx(UIFormControl, {
            characterCount: readerProps.count,
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "toolAccess.message"
            }),
            children: /*#__PURE__*/_jsx(UITextArea, {
              "data-test-id": "ui-tool-access-request-modal-message",
              placeholder: I18n.text('toolAccess.messageOptional'),
              value: readerProps.value,
              onChange: readerProps.onChange,
              maxLength: 200
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "ui-tool-access-modal-submit-button",
          use: "primary",
          type: "submit",
          disabled: !formState.approver,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "toolAccess.sendRequest"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "secondary",
          onClick: onCancel,
          "data-test-id": "tool-access-modal-cancel",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "toolAccess.cancel"
          })
        })]
      })]
    })]
  });
}
export default ToolAccessModal;